let observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === "childList") {
      if (document.querySelector(".status-bar-sign-up")) {
        initScript();
      }
    }
  });
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

function initScript() {
  const statusBar = document.querySelector(".status-bar-sign-up");
  const footerStatus = document.querySelector(".rb-step-footer.ttc");

  if (!statusBar || !footerStatus) return;

  if (statusBar.dataset.initialized) return;

  statusBar.dataset.initialized = "true";
  footerStatus.dataset.initialized = "true";

  const statusBarTitle = statusBar.querySelector(".tlh-title");
  if (statusBarTitle) {
    statusBarTitle.style.display = "none";
    statusBarTitle.insertAdjacentHTML("beforebegin", `<span class="tlh-new-title">Choose your flavours</span>`);
  }

  let totalSpan = statusBar.querySelector(".Total");
  if (!totalSpan) {
    totalSpan = document.createElement("span");
    totalSpan.classList.add("Total");
    totalSpan.textContent = "Total 0";
    totalSpan.dataset.value = "0";
  }

  let buttonNumber = document.querySelector(".ButtonNumber");
  if (!buttonNumber) {
    buttonNumber = document.createElement("span");
    buttonNumber.classList.add("ButtonNumber");
    buttonNumber.textContent = "4 More cases";
    buttonNumber.dataset.value = "4";
  }

  const rbtn = document.querySelector(".status-bar-sign-up .rb-btn");
  if (rbtn) {
    rbtn.innerHTML = "";
    rbtn.appendChild(buttonNumber);
  }

  const firstTlhItemList = document.querySelector(".tlh-item-list");
  if (firstTlhItemList) {
    firstTlhItemList.insertAdjacentElement("beforebegin", totalSpan);
  } else {
    const tflexColumn = document.querySelector(".status-bar-sign-up .tflex-column");
    if (tflexColumn) {
      tflexColumn.insertAdjacentElement("beforebegin", totalSpan);
    }
  }

  // const element = document.querySelector(".thl-copy");
  // if (element) {
  //   const textNode = element.childNodes[0];
  //   if (textNode && textNode.nodeType === 3) textNode.textContent = "";
  // }

  function formatPrices() {
    const priceElements = document.querySelectorAll(".thl-copy span[aria-label]");
    priceElements.forEach((el) => {
      el.innerHTML = el.innerHTML.replace(/£(\d+)\.(\d{2})/g, "£$1");
    });
  }

  const colors = {
    "45827184787714": "#e0bddb", // Blackcurrant
    "45827184623874": "#ffc481", // Orange43028368064582
    "45827184853250": "#bbe3db", // cucumber
    "43028368064582": "#ff73a5", // cherry
    "40210953896006": "#bbe3db",// cucumber1
    "44969594257478": "#FF79C8",// cucumber1
    raspberry: "#faccd4",
    blackcurrant: "#e0bddb",
    peach: "#fdcfb7",
    mango: "#ffdf8d",
    cucumber: "#bbe3db",
    lemon: "#fff9af",
    orange: "#ffc481",
    grapefruit: "#ffb9ba",
    lime: "#c1efa6",
    "cucumber-mint": "#bbe3db",
  };

  const DEFAULT_CHIP_COLOR = "#e5e7eb";

  const tflexColumn = document.querySelector(".status-bar-sign-up .tflex-column");

  function renderChipForInput(inputEl) {
    const row = inputEl.closest(".tflex-row");
    if (!row) return;

    const itemId = row.getAttribute("data-rb-item-id");
    const flavourName = row.querySelector(".rb-title span:last-child")?.textContent?.trim().toLowerCase();
    const dataLabel = itemId || flavourName;

    const existingSpan = document.querySelector(`.tlh-item-list[data-label="${dataLabel}"]`);
    if (existingSpan) existingSpan.remove();

    const qty = parseInt(inputEl.value, 10) || 0;
    if (qty <= 0) return;

    const chip = document.createElement("span");
    chip.classList.add("tlh-item-list");
    chip.setAttribute("data-label", dataLabel);
    chip.textContent = `${qty}`;
    chip.style.backgroundColor = colors[itemId] || colors[flavourName] || DEFAULT_CHIP_COLOR;

    if (tflexColumn) {
      tflexColumn.insertAdjacentElement("beforebegin", chip);
    }
  }

  function rebuildAllChips() {
    const allQty = document.querySelectorAll('.rb-step-main input[type="text"]');
    allQty.forEach(renderChipForInput);
  }

  function updateTotals() {
    const allQty = document.querySelectorAll('.rb-step-main input[type="text"]');
    let totalValue = 0;
    allQty.forEach((el) => (totalValue += parseInt(el.value, 10) || 0));

    if (totalSpan) totalSpan.textContent = `Total ${totalValue}`;

    const required = 4;
    const remaining = required - totalValue;
    const titleSpan = document.querySelector(".rb-sticky-content");

    if (remaining <= 0) {
      buttonNumber.textContent = "Continue";
      if (titleSpan) titleSpan.classList.add("active");
    } else {
      buttonNumber.textContent = `${remaining} More cases`;
      if (titleSpan) titleSpan.classList.remove("active");
    }
  }


  rebuildAllChips();
  updateTotals();
  formatPrices();

  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".rb-btn-qty-plus, .rb-btn-qty-minus");
    if (!btn) return;
    requestAnimationFrame(() => {
      rebuildAllChips();
      updateTotals();
      formatPrices();
    });
  });

  document.addEventListener("input", (e) => {
    if (!(e.target instanceof HTMLInputElement)) return;
    if (!e.target.matches('.rb-step-main input[type="text"]')) return;
    requestAnimationFrame(() => {
      rebuildAllChips();
      updateTotals();
    });
  });

  window.RechargeBundle = window.RechargeBundle || {};
  window.RechargeBundle.onAddToCart = function () {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) cartDrawer.classList.remove("is-empty");

    const cartDrawerItems = document.querySelector("cart-drawer-items");
    if (cartDrawerItems) {
      cartDrawerItems.classList.remove("is-empty");
      if (typeof cartDrawerItems.onCartUpdate === "function") cartDrawerItems.onCartUpdate();
    }

    const drawerInnerEmpty = document.querySelector(".drawer__inner-empty");
    if (drawerInnerEmpty) drawerInnerEmpty.classList.remove("drawer__inner-empty");

    const closeButton = document.querySelector(".drawer__close");
    if (closeButton) closeButton.onclick = () => (window.location.href = "/collections/infused-sparkling-water");

    const cartIcon = document.querySelector(".header__icon--cart");
    if (cartIcon) {
      cartIcon.addEventListener("click", (e) => e.preventDefault());
      setTimeout(() => cartIcon.dispatchEvent(new Event("click", { bubbles: true })), 1000);
    }
  };
}

// Product innerpage

// Accordion
document.querySelectorAll('.accordion-link').forEach(link => {
    link.addEventListener('click', function() {
        const parentItem = this.closest('.accordion__item');
        
        // Check if the clicked item is already open
        const isOpen = parentItem.classList.contains('is-open');

        // Remove 'is-open' class from all items
        document.querySelectorAll('.accordion__item').forEach(item => {
            item.classList.remove('is-open');
        });

        // Toggle the 'is-open' class only if it was not already open
        if (!isOpen) {
            parentItem.classList.add('is-open');
        }
    });
});

// Clone price on sticky wrapper on single product

document.addEventListener("DOMContentLoaded", function () {
  const canValue = document.querySelector('.product-plan-cans');
  const plusBtn = document.querySelector('.quantity__button.plus');
  const minusBtn = document.querySelector('.quantity__button.minus');
  const prodPrice = document.querySelector('.price-item');
  const priceContainer = document.querySelector('.product-price-container');
  const newDiv = document.createElement("div");
  
  newDiv.className = "choose-plan";
  // newDiv.textContent = "Delivered every 30 Days" + " -";
  
  // Insert the new div before the product price
  if (canValue && priceContainer) {
      canValue.parentNode.insertBefore(newDiv, priceContainer);
  }

  let value = parseFloat(canValue.textContent); // Initial can count
  let fixedValue = parseFloat(canValue.dataset.fixedPrice); // Increment step

  function getBasedPrice() {
    return parseFloat(prodPrice.textContent.replace(/[^0-9.]/g, '')) || 0;
  }

  let basedPrice = getBasedPrice();

  function updateUI() {
    canValue.textContent = `${value} cans`;

    let totalPrice = basedPrice * (value / fixedValue); // Adjust price based on quantity
    priceContainer.textContent = `£${totalPrice.toFixed(2)}`;
    priceContainer.dataset.productPrice = `£${totalPrice.toFixed(2)}`;

    newDiv.dataset.planPrice = basedPrice.toFixed(2);

    minusBtn.disabled = value <= fixedValue; // Disable minus button at minimum limit
  }

  plusBtn.addEventListener("click", function () {
    value += fixedValue; // Increase the value
    updateUI();
  });

  minusBtn.addEventListener("click", function () {
    if (value > fixedValue) { // Prevent going below fixed value
      value -= fixedValue;
      updateUI();
    }
  });

  if (prodPrice) {
    const observer = new MutationObserver(() => {
      basedPrice = getBasedPrice(); // Update base price when `.price-item` changes
      updateUI(); // Ensure correct calculations after price update
    });

    observer.observe(prodPrice, { childList: true, subtree: true, characterData: true });
  }

  updateUI(); // Initialize UI on page load
});


// Recharge plan product page
document.addEventListener("DOMContentLoaded", function () {
  const paymentForm = document.querySelector('.installment'); 
  const selectedPlanText = document.getElementById("selected-plan-text");
  const selectedPlanInput = document.getElementById("selected-plan");
  const deliveryDropdown = document.querySelector('[data-plans-dropdown]');
  const plansDropdownContainer = document.querySelector('.rc_widget__option__plans__dropdown'); // Select the dropdown container

  if (paymentForm) {
    paymentForm.addEventListener("change", function (event) {
      let selectedOption = "";

      if (event.target.type === "radio") {
        if (event.target.value.toLowerCase() === "subsave") {
          selectedOption = "Delivery every 14 Days";

          if (deliveryDropdown) {
            deliveryDropdown.value = deliveryDropdown.options[0].value; 
            selectedOption = deliveryDropdown.options[0].dataset.planOption || "Delivery every 14 Days"; 
          }

          // Refresh the plans dropdown by temporarily hiding and showing it
          if (plansDropdownContainer) {
            plansDropdownContainer.style.display = "none";
            setTimeout(() => {
              plansDropdownContainer.style.display = "block";
            }, 50); // Short delay to allow re-render
          }
        } else {
          selectedOption = "Delivered One Time";
        }
      }

      if (event.target.tagName === "SELECT" && event.target.dataset.plansDropdown !== undefined) {
        selectedOption = event.target.options[event.target.selectedIndex].dataset.planOption || "Delivery every 14 Days";
      }

      if (selectedOption) {
        selectedPlanText.innerText = selectedOption;
        selectedPlanInput.value = selectedOption;
      }
    });
  }
});


// Header bubble append
document.addEventListener("DOMContentLoaded", () => {
  let previousCount = null; // Store previous count to track changes

  const updateCartBubble = () => {
    const cartCountElement = document.querySelector(".cart-final-count");
    const cartBubbleElement = document.querySelector(".cart-count-header-bubble");

    if (!cartCountElement || !cartBubbleElement) return;

    let cartCount = cartCountElement.textContent.match(/\d+/)?.[0] || "0";
    
    // Format single-digit numbers to two digits (e.g., "5" → "05")
    cartCount = cartCount.padStart(2, "0");

    if (cartCount !== previousCount) {
      if (parseInt(cartCount) > 0) {
        cartBubbleElement.textContent = cartCount;
        cartBubbleElement.style.display = "flex"; // Show if count > 0
      } else {
        cartBubbleElement.style.display = "none"; // Hide if count is 0 or empty
      }
      previousCount = cartCount;
    }
  };

  // MutationObserver for real-time changes
  const cartCountElement = document.querySelector(".cart-final-count");
  if (cartCountElement) {
    const observer = new MutationObserver(updateCartBubble);
    observer.observe(cartCountElement, { childList: true, subtree: true });
  }

  // Fallback: Check for changes every 500ms in case MutationObserver fails
  setInterval(updateCartBubble, 500);

  // Run immediately on page load
  updateCartBubble();
});

// Customer portal popup
document.addEventListener("DOMContentLoaded", function () {
    function attachClickEvent() {
        const referFriendBtns = document.querySelectorAll(".refer-friend");
        const pointsBtns = document.querySelectorAll(".additional-sidebar-slot.points");
        const closePopupBtns = document.querySelectorAll(".close-popup-btn");

        function disableScroll() {
            document.body.style.overflow = "hidden"; // Prevent scrolling
        }

        function enableScroll() {
            document.body.style.overflow = ""; // Restore scrolling
        }

        function openPopup(popupSelector) {
            let popup = document.querySelector(popupSelector);
            if (popup) {
                popup.classList.add("active");
                disableScroll();
            }
        }

        function closePopup(btn) {
            let popup = btn.closest(".refer-friend-popup, .points-popup");
            if (popup) {
                popup.classList.remove("active");

                // Check if any popup is still open before enabling scroll
                if (!document.querySelector(".refer-friend-popup.active") &&
                    !document.querySelector(".points-popup.active")) {
                    enableScroll();
                }
            }
        }

        // Handle Refer Friend popup
        referFriendBtns.forEach((btn) => {
            if (!btn.dataset.listenerAdded) {
                btn.addEventListener("click", function () {
                    openPopup(".refer-friend-popup");
                });
                btn.dataset.listenerAdded = "true";
            }
        });

        // Handle Points popup
        pointsBtns.forEach((btn) => {
            if (!btn.dataset.listenerAdded) {
                btn.addEventListener("click", function () {
                    openPopup(".points-popup");
                });
                btn.dataset.listenerAdded = "true";
            }
        });

        // Close popups
        closePopupBtns.forEach((btn) => {
            if (!btn.dataset.listenerAdded) {
                btn.addEventListener("click", function () {
                    closePopup(this);
                });
                btn.dataset.listenerAdded = "true";
            }
        });
    }

    // Observe changes in the DOM
    const observer = new MutationObserver((mutations) => {
        mutations.forEach(() => {
            attachClickEvent();
        });
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Initial check in case elements are already in the DOM
    attachClickEvent();
});

// Account order history toggle button

document.addEventListener("DOMContentLoaded", function () {
    const orderHistory = document.querySelector(".order--history");
    const accountDetails = document.querySelector(".account__Details");

    if (orderHistory && accountDetails) {
        orderHistory.addEventListener("click", function () {
            accountDetails.classList.toggle("order-history-open"); // Change 'active' to your desired class
        });
    }
});

// remove specific product from customer portal
document.addEventListener("DOMContentLoaded", function () {
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (node.nodeType === 1) { // Ensure it's an element node
                    checkAndApplyBorder(node);
                }
            });
        });
    });

    function checkAndApplyBorder(element) {
        let spans = element.querySelectorAll("span");
        spans.forEach(span => {
            if (span.textContent.trim() === "PICK & MIX SPARKLING WATER2") {
                let productItem = span.closest(".recharge-component-product-item");
                if (productItem) {
                    let parentDiv = productItem.closest("div._15b7gxl0._17o99wpir");
                    if (parentDiv) {
                        parentDiv.style.display = "none";
                    }
                }
            }
        });
    }

    // Start observing changes in the body (or a specific container)
    observer.observe(document.body, { childList: true, subtree: true });

    // Run the check initially in case the elements are already present
    document.querySelectorAll(".recharge-component-product-item").forEach(checkAndApplyBorder);
});

// Mobile menu submenu toggle

document.querySelectorAll('.menu-drawer__menu > li').forEach(li => {
  li.addEventListener('click', function () {
    const isActive = this.classList.contains('active');

    document.querySelectorAll('.menu-drawer__menu > li.active').forEach(activeLi => {
      activeLi.classList.remove('active');
    });

    if (!isActive) {
      this.classList.add('active');
    }
  });
});

// Pick mix bundle info card

const insertBundleInfo = () => {
  const rbStepMain = document.querySelector('.rb-step-main');

  if (rbStepMain && !rbStepMain.querySelector('.bundle-overview--info')) {
    const newDiv = document.createElement('div');
    newDiv.className = 'bundle-overview--info';

    newDiv.innerHTML = `
  <h1 class="bundle-overview--title">PICK &amp; MIX</h1>
  <!-- junip Star Rating -->
  <span class="junip-product-summary" data-product-id="4542895423558"> </span>
  <!-- End of junip -->
  <div class="bundle-overview--description">
    Craft your perfect 48-can collection with our Pick & Mix bundle.<span class="read-more-link" data-rm="open" style="cursor:pointer;">...<u data-rm="open">Read More</u></span>
    <span class="bundle-overview--more" hidden>
      <br><br>Hand-pick your favourite soft drinks from our full range
      of delicious flavours. Every can of our sparkling water is
      infused with real, wonky fruit and contains absolutely
      no sugar, sweeteners, or calories.<br><br>There's just pure,
      natural refreshment in a selection designed by you, for
      you.
      <span class="read-less-link" data-rm="close" style="cursor:pointer;text-decoration:underline;">Read Less</span>
    </span>
  </div>
`;
newDiv.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-rm]');
  if (!trigger || !newDiv.contains(trigger)) return;

  const more = newDiv.querySelector('.bundle-overview--more');
  const openWrap = newDiv.querySelector('.read-more-link');

  if (trigger.dataset.rm === 'open') {
    more.hidden = false;
    if (openWrap) openWrap.style.display = 'none';
  } else if (trigger.dataset.rm === 'close') {
    more.hidden = true;
    if (openWrap) openWrap.style.display = '';
  }
});

    // Keep your original placement method
    rbStepMain.appendChild(newDiv); // or prepend() if that's what you had originally
    return true;
  }

  return false;
};

// Keep checking until it works
const tryInsert = setInterval(() => {
  const success = insertBundleInfo();
  if (success) clearInterval(tryInsert);
}, 300);

// Stop checking after 10 seconds
setTimeout(() => clearInterval(tryInsert), 10000);

// Pick mix bundle bottom block reviews

const insertBundleReviews = () => {
  const wrapper = document.querySelector('.rb-step-wrapper');
  const body = wrapper?.querySelector('.rb-step-body');

  if (wrapper && body && !wrapper.querySelector('.bundle-block-reviews-container')) {
    const newDiv = document.createElement('div');
    newDiv.className = 'bundle-block-reviews-container';

    // Grab the flavour block section by unique ID
const flavourSection = document.querySelector('[id$="__flavour_block_xPAfzw"]');
    let flavourHTML = '';
    if (flavourSection) {
      flavourHTML = flavourSection.innerHTML;
    }

    // Build the block with flavour above reviews
    newDiv.innerHTML = `
      ${flavourHTML}
      <div class="pick-mix-reviews-wrapper"></div>
      <span class="junip-product-review" data-product-id="4542895423558"></span>
    `;

    body.insertAdjacentElement('afterend', newDiv);

    // Optional: hide original section to prevent duplicate display
    if (flavourSection) {
      flavourSection.style.display = 'none';
    }

    return true;
  }

  return false;
};

// Keep trying to insert until it succeeds
const tryInsertReviews = setInterval(() => {
  const success = insertBundleReviews();
  if (success) clearInterval(tryInsertReviews);
}, 300);

// Stop trying after 10 seconds
setTimeout(() => clearInterval(tryInsertReviews), 10000);

// Recharge widget remove decimal

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    document.querySelectorAll('.rc-selling-plans-dropdown__price').forEach((el) => {
      const match = el.textContent.match(/£(\d+)\.00/);
      if (match) {
        el.textContent = `£${match[1]}`;
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});

// Pick and mix subscription widget

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          const target = node.matches('.rb-frequency-select-wrapper')
            ? node
            : node.querySelector('.rb-frequency-select-wrapper');

          if (target && !target.dataset.modified) {
            // Prevent duplicate insertions
            if (!target.nextElementSibling || !target.nextElementSibling.classList.contains('new-frequency-select-wrapper')) {
              // Mark as modified
              target.dataset.modified = "true";

              // Create new div and add content
              const newDiv = document.createElement("div");
              newDiv.className = "new-frequency-select-wrapper";

              // Find the select element
              const selectElement = target.querySelector('.rb-select.rb-frequency-select.tmw-100');
              if (selectElement) {
                // Clone the select element
                const clonedSelect = selectElement.cloneNode(true);

                // Add event listener
                clonedSelect.addEventListener('change', function (event) {
                  console.log('Selection changed to:', event.target.value);
                });

                // Append cloned select to new div
                newDiv.appendChild(clonedSelect);
              }

              // Insert the new div after the target
              target.parentNode.insertBefore(newDiv, target.nextSibling);
            }
          }
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});



